import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showError } from '../snackbars/snackbars-actions';
import BookingSummaryView from './booking-summary-view';

class BookingSummary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      details: null,
      waypoints: [
        {
          latitude: 51.4497,
          longitude: 0.102906
        },
        {
          latitude: 51.4576,
          longitude: 0.0976003
        },
        {
          latitude: 51.449,
          longitude: 0.0828646
        }
      ]
    }
  }

  toggleBooking = () => {
    this.setState({ expanded: !this.state.expanded });
    // Api.post('p/journey-report', { deliveryId: 1, asBusinessId: 1 })
    //   .then((resp) => {
    //
    //     console.log(resp);
    //
    //     if (resp.err) return this.props.showError(resp.err);
    //
    //     this.setState({
    //       details: resp
    //     })
    //
    //   })
  };

  render() {
    return <BookingSummaryView waypoints={this.state.waypoints} {...this.props} toggleBooking={this.toggleBooking} expanded={this.state.expanded} details={this.state.details} />
  }

}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage
});

const mapDispatchToProps = {
  showError: showError,
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingSummary);



// WEBPACK FOOTER //
// ./src/components/booking-summary/booking-summary.js